import { WithdrawDialog } from '@bz/wallet';

export const route: RouteDefinition = {
  preload: () => {},
  info: {
    login: true,
    dialog: {
      get title() {
        return t('Withdraw');
      },
      class: 'w-[500px] h-[700px] [&>.dialog-wrap>.dialog-title]:!bg-layer5',
    },
  },
};

export default WithdrawDialog;
